<ng-container *ngIf="aggregates != null">
  <div class="scrollbar" *ngIf="aggregates | async as syncAggregates">
    <div class="no-data" *ngIf="syncAggregates.length === 0 && !showLoader">
      No accounts
    </div>
    <button
      *ngFor="let agg of syncAggregates"
      type="button"
      class="dropdown-item btn btn-link"
      (click)="onClick(agg)"
    >
      {{ agg.accountId }} - {{ agg.shortName }}
    </button>
  </div>
  <div class="loader" [hidden]="!showLoader">
    <div *nfLoader="showLoader"></div>
  </div>
</ng-container>
